const lrtCommon = {
  en: {
    lrt: "Light Rail",
    stn: "Light Rail Station",
    plat: "Platform",
    select: "Please Select",
    etaAlert:
      "ETA information will be refresh every 10 seconds, reference data only.",
    autoBtnOn: "Auto",
    autoBtnOff: "Auto",
    title: "Light Rail ETA",
    lastUpdate: "Last Update",
    to: "To ",
    depHere: "Dep. Here",
    dep: "Maybe Departed",
    end_service: "End of today's service",
    zone: "Fare Zone",
    route: "Route",
    saveStation: "Saved Light Rail Station",
    saveFalse: "Save",
    saveTrue: "Saved",
    routeMap: "Route",
  },
  tc: {
    lrt: "輕鐵",
    stn: "輕鐵站",
    plat: "月台",
    select: "請選擇",
    etaAlert: "到站時間資訊每10秒自動更新，資料只供參考。",
    autoBtnOn: "自動",
    autoBtnOff: "自動",
    title: "輕鐵 到站時間",
    lastUpdate: "最後更新",
    to: "往",
    depHere: "此站開出",
    dep: "可能已經開出",
    end_service: "本日服務完結",
    zone: "收費區",
    route: "路線",
    saveStation: "已儲存輕鐵站",
    saveFalse: "儲存",
    saveTrue: "已儲存",
    routeMap: "路線圖",
  },
};

const lrtStations = {
  1: {
    tc_name: "屯門碼頭",
    en_name: "Tuen Mun Ferry Pier",
    lag: 22.372897,
    lon: 113.9488716,
    zone: "1",
    active: "1",
  },
  10: {
    tc_name: "美樂",
    en_name: "Melody Garden",
    lag: 22.3750707,
    lon: 113.9585368,
    zone: "1",
    active: "1",
  },
  15: {
    tc_name: "蝴蝶",
    en_name: "Butterfly",
    lag: 22.37812,
    lon: 113.9591951,
    zone: "1",
    active: "1",
  },
  20: {
    tc_name: "輕鐵車廠",
    en_name: "Light Rail Depot",
    lag: 22.310393,
    lon: 114.2271582,
    zone: "1",
    active: "1",
  },
  30: {
    tc_name: "龍門",
    en_name: "Lung Mun",
    lag: 22.3860507,
    lon: 113.9570323,
    zone: "1",
    active: "1",
  },
  40: {
    tc_name: "青山村",
    en_name: "Tsing Shan Tsuen",
    lag: 22.310393,
    lon: 114.2271582,
    zone: "2",
    active: "1",
  },
  50: {
    tc_name: "青雲",
    en_name: "Tsing Wun",
    lag: 22.3825242,
    lon: 113.9536689,
    zone: "2",
    active: "1",
  },
  60: {
    tc_name: "建安",
    en_name: "Kin On",
    lag: 22.4067251,
    lon: 113.951126,
    zone: "2",
    active: "1",
  },
  70: {
    tc_name: "河田",
    en_name: "Ho Tin",
    lag: 22.3093594,
    lon: 113.6059472,
    zone: "2",
    active: "1",
  },
  75: {
    tc_name: "蔡意橋",
    en_name: "Choy Yee Bridge",
    lag: 22.3998493,
    lon: 113.9715208,
    zone: "2",
    active: "1",
  },
  80: {
    tc_name: "澤豐",
    en_name: "Affluence",
    lag: 22.403925,
    lon: 113.9734683,
    zone: "2",
    active: "1",
  },
  90: {
    tc_name: "屯門醫院",
    en_name: "Tuen Mun Hospital",
    lag: 22.3924522,
    lon: 113.9514835,
    zone: "3",
    active: "1",
  },
  100: {
    tc_name: "兆康",
    en_name: "Siu Hong",
    lag: 22.4110789,
    lon: 113.9761196,
    zone: "3",
    active: "1",
  },
  110: {
    tc_name: "麒麟",
    en_name: "Kei Lun",
    lag: 22.411052,
    lon: 113.9737749,
    zone: "3",
    active: "1",
  },
  120: {
    tc_name: "青松",
    en_name: "Ching Chung",
    lag: 22.4072822,
    lon: 113.9700163,
    zone: "3",
    active: "1",
  },
  130: {
    tc_name: "建生",
    en_name: "Kin Sang",
    lag: 22.4067251,
    lon: 113.9665755,
    zone: "3",
    active: "1",
  },
  140: {
    tc_name: "田景",
    en_name: "Tin King",
    lag: 22.4077194,
    lon: 113.9619239,
    zone: "3",
    active: "1",
  },
  150: {
    tc_name: "良景",
    en_name: "Leung King",
    lag: 22.3648231,
    lon: 113.9293918,
    zone: "3",
    active: "1",
  },
  160: {
    tc_name: "新圍",
    en_name: "San Wai",
    lag: 22.405295,
    lon: 113.9618938,
    zone: "3",
    active: "1",
  },
  170: {
    tc_name: "石排",
    en_name: "Shek Pai",
    lag: 22.4019395,
    lon: 113.9653916,
    zone: "2",
    active: "1",
  },
  180: {
    tc_name: "山景 (北)",
    en_name: "Shan King (North)",
    lag: 22.3977627,
    lon: 113.964018,
    zone: "2",
    active: "1",
  },
  190: {
    tc_name: "山景 (南)",
    en_name: "Shan King (South)",
    lag: 22.396636,
    lon: 113.9634951,
    zone: "2",
    active: "1",
  },
  200: {
    tc_name: "鳴琴",
    en_name: "Ming Kum",
    lag: 22.396738,
    lon: 113.9648291,
    zone: "2",
    active: "1",
  },
  212: {
    tc_name: "大興 (北)",
    en_name: "Tai Hing (North)",
    lag: 22.4045936,
    lon: 113.8258032,
    zone: "2",
    active: "1",
  },
  220: {
    tc_name: "大興 (南)",
    en_name: "Tai Hing (South)",
    lag: 22.4028213,
    lon: 113.9694638,
    zone: "2",
    active: "1",
  },
  230: {
    tc_name: "銀圍",
    en_name: "Ngan Wai",
    lag: 22.405295,
    lon: 113.8202731,
    zone: "2",
    active: "1",
  },
  240: {
    tc_name: "兆禧",
    en_name: "Siu Hei",
    lag: 22.4117535,
    lon: 113.690605,
    zone: "1",
    active: "1",
  },
  250: {
    tc_name: "屯門泳池",
    en_name: "Tuen Mun Swimming Pool",
    lag: 22.3924361,
    lon: 113.9504842,
    zone: "1",
    active: "1",
  },
  260: {
    tc_name: "豐景園",
    en_name: "Goodview Garden",
    lag: 22.3836753,
    lon: 113.9702344,
    zone: "1",
    active: "1",
  },
  265: {
    tc_name: "兆麟",
    en_name: "Siu Lun",
    lag: 22.3845891,
    lon: 113.9725099,
    zone: "1",
    active: "1",
  },
  270: {
    tc_name: "安定",
    en_name: "On Ting",
    lag: 22.3977694,
    lon: 113.9604503,
    zone: "2",
    active: "1",
  },
  275: {
    tc_name: "友愛",
    en_name: "Yau Oi",
    lag: 22.386726,
    lon: 113.971022,
    zone: "2",
    active: "1",
  },
  280: {
    tc_name: "市中心",
    en_name: "Town Centre",
    lag: 22.391414,
    lon: 113.9723981,
    zone: "2",
    active: "1",
  },
  295: {
    tc_name: "屯門",
    en_name: "Tuen Mun",
    lag: 22.3852141,
    lon: 113.9714055,
    zone: "2",
    active: "1",
  },
  300: {
    tc_name: "杯渡",
    en_name: "Pui To",
    lag: 22.39451,
    lon: 113.9738081,
    zone: "2",
    active: "1",
  },
  310: {
    tc_name: "何福堂",
    en_name: "Hoh Fuk Tong",
    lag: 22.3974234,
    lon: 113.9748279,
    zone: "2",
    active: "1",
  },
  320: {
    tc_name: "新墟",
    en_name: "San Hui",
    lag: 22.4002546,
    lon: 113.9754053,
    zone: "2",
    active: "1",
  },
  330: {
    tc_name: "景峰",
    en_name: "Prime View",
    lag: 22.4032009,
    lon: 113.9768666,
    zone: "2",
    active: "1",
  },
  340: {
    tc_name: "鳳地",
    en_name: "Fung Tei",
    lag: 22.4070101,
    lon: 113.9762556,
    zone: "3",
    active: "1",
  },
  350: {
    tc_name: "藍地",
    en_name: "Lam Tei",
    lag: 22.418384,
    lon: 113.9797011,
    zone: "3",
    active: "1",
  },
  360: {
    tc_name: "泥圍",
    en_name: "Nai Wai",
    lag: 22.4240263,
    lon: 113.8425907,
    zone: "3",
    active: "1",
  },
  370: {
    tc_name: "鍾屋村",
    en_name: "Chung Uk Tsuen",
    lag: 22.42965,
    lon: 113.9877739,
    zone: "3",
    active: "1",
  },
  380: {
    tc_name: "洪水橋",
    en_name: "Hung Shui Kiu",
    lag: 22.4335513,
    lon: 113.9950436,
    zone: "4",
    active: "1",
  },
  390: {
    tc_name: "塘坊村",
    en_name: "Tong Fong Tsuen",
    lag: 22.4401113,
    lon: 114.0044869,
    zone: "4",
    active: "1",
  },
  400: {
    tc_name: "屏山",
    en_name: "Ping Shan",
    lag: 22.44278,
    lon: 114.0074339,
    zone: "4",
    active: "1",
  },
  425: {
    tc_name: "坑尾村",
    en_name: "Hang Mei Tsuen",
    lag: 22.4451427,
    lon: 114.0033861,
    zone: "4",
    active: "1",
  },
  430: {
    tc_name: "天水圍",
    en_name: "Tin Shui Wai",
    lag: 22.4520597,
    lon: 113.9969399,
    zone: "4",
    active: "1",
  },
  435: {
    tc_name: "天慈",
    en_name: "Tin Tsz",
    lag: 22.4527223,
    lon: 114.0035474,
    zone: "4",
    active: "1",
  },
  445: {
    tc_name: "天耀",
    en_name: "Tin Yiu",
    lag: 22.4503621,
    lon: 114.0001213,
    zone: "4",
    active: "1",
  },
  448: {
    tc_name: "樂湖",
    en_name: "Locwood",
    lag: 22.4530661,
    lon: 113.9986297,
    zone: "4",
    active: "1",
  },
  450: {
    tc_name: "天湖",
    en_name: "Tin Wu",
    lag: 22.4549672,
    lon: 114.0031801,
    zone: "4",
    active: "1",
  },
  455: {
    tc_name: "銀座",
    en_name: "Ginza",
    lag: 22.45688,
    lon: 114.0032051,
    zone: "4",
    active: "1",
  },
  460: {
    tc_name: "天瑞",
    en_name: "Tin Shui",
    lag: 22.4563507,
    lon: 113.9908675,
    zone: "4",
    active: "1",
  },
  468: {
    tc_name: "頌富",
    en_name: "Chung Fu",
    lag: 22.46193,
    lon: 113.9944451,
    zone: "5a",
    active: "1",
  },
  480: {
    tc_name: "天富",
    en_name: "Tin Fu",
    lag: 22.4632296,
    lon: 113.9947307,
    zone: "5a",
    active: "1",
  },
  490: {
    tc_name: "翠湖",
    en_name: "Chestwood",
    lag: 22.3743697,
    lon: 113.9100815,
    zone: "4",
    active: "1",
  },
  500: {
    tc_name: "天榮",
    en_name: "Tin Wing",
    lag: 22.4335615,
    lon: 113.9443321,
    zone: "4",
    active: "1",
  },
  510: {
    tc_name: "天悅",
    en_name: "Tin Yuet",
    lag: 22.4628243,
    lon: 113.9990881,
    zone: "5a",
    active: "1",
  },
  520: {
    tc_name: "天秀",
    en_name: "Tin Sau",
    lag: 22.4481727,
    lon: 113.7162426,
    zone: "5a",
    active: "1",
  },
  530: {
    tc_name: "濕地公園",
    en_name: "Wetland Park",
    lag: 22.4696008,
    lon: 113.9999867,
    zone: "5a",
    active: "1",
  },
  540: {
    tc_name: "天恒",
    en_name: "Tin Heng",
    lag: 22.469705,
    lon: 113.9981647,
    zone: "5a",
    active: "1",
  },
  550: {
    tc_name: "天逸",
    en_name: "Tin Yat",
    lag: 22.4668296,
    lon: 113.9946884,
    zone: "5a",
    active: "1",
  },
  560: {
    tc_name: "水邊圍",
    en_name: "Shui Pin Wai",
    lag: 22.4444487,
    lon: 114.0172817,
    zone: "5",
    active: "1",
  },
  570: {
    tc_name: "豐年路",
    en_name: "Fung Nin Road",
    lag: 22.4444805,
    lon: 114.0212412,
    zone: "5",
    active: "1",
  },
  580: {
    tc_name: "康樂路",
    en_name: "Hong Lok Road",
    lag: 22.444484,
    lon: 114.0243421,
    zone: "5",
    active: "1",
  },
  590: {
    tc_name: "大棠路",
    en_name: "Tai Tong Road",
    lag: 22.4445202,
    lon: 114.0264402,
    zone: "5",
    active: "1",
  },
  600: {
    tc_name: "元朗",
    en_name: "Yuen Long",
    lag: 22.445829,
    lon: 114.0312391,
    zone: "5",
    active: "1",
  },
  920: {
    tc_name: "三聖",
    en_name: "Sam Shing",
    lag: 22.382979,
    lon: 113.9748501,
    zone: "1",
    active: "1",
  },
};

const lrtRoutes = {
  505: {
    route_name: "",
    route_rmk: "",
    colorCode: "#db1f26",
    stations: [
      100, 120, 130, 140, 150, 160, 170, 200, 60, 295, 280, 270, 265, 920,
    ],
  },
  507: {
    route_name: "",
    route_rmk: "",
    colorCode: "#00a650",
    stations: [
      140, 150, 160, 212, 220, 230, 75, 70, 295, 280, 270, 265, 260, 250, 1,
    ],
  },
  610: {
    route_name: "",
    route_rmk: "",
    colorCode: "#431115",
    stations: [
      1, 10, 15, 20, 30, 40, 50, 200, 170, 212, 220, 230, 80, 90, 100, 350, 260,
      270, 380, 390, 400, 560, 570, 580, 590, 600,
    ],
  },
  614: {
    route_name: "",
    route_rmk: "",
    colorCode: "#4dc6f4",
    stations: [
      1, 240, 250, 260, 265, 270, 280, 300, 310, 320, 330, 340, 100, 350, 360,
      370, 380, 390, 400, 560, 570, 580, 590, 600,
    ],
  },
  "614P": {
    route_name: "",
    route_rmk: "",
    colorCode: "#f46989",
    stations: [1, 240, 250, 260, 265, 270, 280, 300, 310, 320, 330, 340, 100],
  },
  615: {
    route_name: "",
    route_rmk: "",
    colorCode: "#fddd04",
    stations: [
      1, 10, 15, 20, 30, 40, 50, 200, 170, 160, 150, 140, 130, 120, 110, 100,
      350, 360, 370, 380, 390, 400, 560, 570, 580, 590, 600,
    ],
  },
  "615P": {
    route_name: "",
    route_rmk: "",
    colorCode: "#215483",
    stations: [
      1, 10, 15, 20, 30, 40, 50, 200, 170, 160, 150, 140, 130, 120, 110, 100,
    ],
  },
  705: {
    route_name: "天水圍循環線 TSW Circular",
    route_rmk: "",
    route_type: "loop",
    colorCode: "#64c542",
    stations: [
      430, 435, 450, 455, 500, 510, 520, 530, 540, 550, 480, 468, 460, 448, 445,
    ],
  },
  706: {
    route_name: "天水圍循環線 TSW Circular",
    route_rmk: "",
    route_type: "loop",
    colorCode: "#b365b9",
    stations: [
      430, 445, 448, 460, 468, 480, 550, 540, 530, 520, 510, 500, 455, 450, 435,
    ],
  },
  751: {
    route_name: "",
    route_rmk: "",
    colorCode: "#f47216",
    stations: [
      550, 480, 468, 490, 500, 455, 450, 435, 430, 425, 380, 370, 360, 350, 100,
      80, 90, 75, 295, 270, 275,
    ],
  },
  "751P": {
    route_name: "",
    route_rmk: "",
    colorCode: "#000000",
    stations: [400, 435, 450, 455, 500, 490, 468, 480, 550],
  },
  "761P": {
    route_name: "",
    route_rmk: "",
    colorCode: "#672290",
    stations: [
      550, 480, 468, 460, 448, 445, 425, 390, 400, 560, 570, 580, 590, 600,
    ],
  },
};

const lrtZoneNames = {
  1: {
    tc_name: "第1收費區",
    en_name: "Fare Zone 1",
  },
  2: {
    tc_name: "第2收費區",
    en_name: "Fare Zone 2",
  },
  3: {
    tc_name: "第3收費區",
    en_name: "Fare Zone 3",
  },
  4: {
    tc_name: "第4收費區",
    en_name: "Fare Zone 4",
  },
  5: {
    tc_name: "第5收費區",
    en_name: "Fare Zone 5",
  },
  "5a": {
    tc_name: "第5A收費區",
    en_name: "Fare Zone 5A",
  },
};

const lrtZoneStation = {
  1: [1, 10, 15, 20, 30, 240, 250, 260, 265, 920],
  2: [
    40, 50, 60, 70, 75, 80, 170, 180, 190, 200, 212, 220, 230, 270, 275, 280,
    295, 300, 310, 320, 330,
  ],
  3: [90, 100, 110, 120, 130, 140, 150, 160, 340, 350, 360, 370],
  4: [380, 390, 400, 425, 430, 435, 445, 448, 450, 455, 460, 490, 500],
  5: [560, 570, 580, 590, 600],
  "5a": [468, 480, 510, 520, 530, 540, 550],
};

const LRT_Dict = {
  lrtZoneStation,
  lrtZoneNames,
  lrtStations,
  lrtCommon,
  lrtRoutes,
};

export default LRT_Dict;
